import axios from "axios";

import { MaybeS3Response } from "@src/api/types/api";

export async function maybeLoadS3Json<Response>(
  response: MaybeS3Response<Response>
): Promise<Response> {
  if (
    typeof response === "object" &&
    response !== null &&
    "type" in response &&
    response.type === "s3"
  ) {
    const s3Response = await axios.get(response.url, {
      responseType: "json",
    });
    return s3Response.data as Response;
  } else {
    return response as Response;
  }
}
